import React, { useEffect } from "react";
import "./style/style.scss";
import { useMediaQuery } from "@mui/material";
import CalendarConfirmationModal from "../ConfirmationModal/CalendarConfirmationModal";
import useCalendarModal from "./hooks/useCalendarModal";
import CalendarDesktopView from "./CalendarDesktopView";
import CalendarMobileView from "./CalendarMobileView";

interface IProps {
  exerciseName: string;
  zone: number;
}

const CalendarModal: React.FC<IProps> = ({ exerciseName, zone }: IProps) => {
  const isDesktop = useMediaQuery("(min-width: 1100px)");

  const {
    selectionState,
    handleTimeSelection,
    handleDateSelect,
    exercise,
    selectedDate,
    listaDat,
    firstAvailableDate,
    soldOutDates,
    alerts,
    isConfirmationModalOpen,
    toggleConfirmationModal,
    joinToExerciseByPass,
    refreshCapacityAfterAddTicket,
    modifiedAlwaysShowHoursToChoose,
    init,
  } = useCalendarModal(exerciseName);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isDesktop ? (
        <CalendarDesktopView
          selectedDate={selectedDate}
          exerciseName={exerciseName}
          listaDat={listaDat}
          firstAvailableDate={firstAvailableDate}
          soldOutDates={soldOutDates}
          exercise={exercise}
          alerts={alerts}
          selectionState={selectionState}
          onDateSelect={handleDateSelect}
          onTimeSelect={handleTimeSelection}
          joinToExerciseByPass={joinToExerciseByPass}
          refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
          showHoursToChoose={modifiedAlwaysShowHoursToChoose}
        />
      ) : (
        <CalendarMobileView
          selectedDate={selectedDate}
          exerciseName={exerciseName}
          listaDat={listaDat}
          firstAvailableDate={firstAvailableDate}
          soldOutDates={soldOutDates}
          exercise={exercise}
          alerts={alerts}
          selectionState={selectionState}
          onDateSelect={handleDateSelect}
          onTimeSelect={handleTimeSelection}
          joinToExerciseByPass={joinToExerciseByPass}
          refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
          showHoursToChoose={modifiedAlwaysShowHoursToChoose}
        />
      )}

      <CalendarConfirmationModal isOpen={isConfirmationModalOpen} onClose={() => toggleConfirmationModal(false)} />
    </>
  );
};

export default CalendarModal;
